<!--suppress TypeScriptUnresolvedVariable -->
<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<form [hidden]="currentPage !== 1" class="po-pdf page-1">
    <div class="header">{{headerText}}</div>

    <div class="intro">
        <span class="intro-regular">{{introRegularText1}} {{introRegularText2}}</span>
    </div>

    <div class="parties" [innerHTML]="partiesTextHTML"></div>

    <div class="po-info">
        <table>
            <tr><th *ngFor="let column of columns" [style.width]="column.widthPercent + '%'" [style.text-align]="'center'">{{column.title}}</th></tr>
            <tr class="bordered-row">
                <td [style.width]="columns[0].widthPercent + '%'" [style.textAlign]="'center'" rowspan="2">{{poManager.current.number}}</td>
                <td [style.width]="columns[1].widthPercent + '%'" [style.textAlign]="'center'">Converters</td>
                <td [style.width]="columns[2].widthPercent + '%'" [style.textAlign]="'center'">{{poManager.current.totalNumConverters}}</td>
                <td [style.width]="columns[3].widthPercent + '%'" [style.textAlign]="'center'">{{poManager.current.totalConvertersPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[4].widthPercent + '%'" [style.whiteSpace]="'nowrap'" [style.textAlign]="'center'" rowspan="2">{{poManager.current.totalPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[5].widthPercent + '%'" [style.textAlign]="'center'">                            
                    <p-inputNumber [inputStyle]="{'width': '100px', 'backgroundColor': 'white', 'border': '1px solid gray'}" [(ngModel)]="poManager.current.catsAdjustment" (ngModelChange)="poManager.adjustmentChange()" inputId="currency-us" mode="currency" [currency]="userCurrency" locale="en-US" [ngModelOptions]="{standalone: true}" />
                </td>
                <td style="width: 15%; text-align: center; white-space: nowrap; padding: 0 10px" rowspan="2">{{poManager.current.totalAdjusted | currency:poManager.current.currency:true}}</td>
            </tr>
            <tr class="bordered-row">
                <!-- <td [style.width]="columns[0].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.number}}</td> -->
                <td [style.width]="columns[1].widthPercent + '%'" [style.text-align]="'center'">Non-Ferrous</td>
                <td [style.width]="columns[2].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.numMiscellaneous}}</td>
                <td [style.width]="columns[3].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.totalMiscPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[5].widthPercent + '%'" [style.textAlign]="'center'">                            
                    <p-inputNumber [inputStyle]="{'width': '100px', 'backgroundColor': 'white', 'border': '1px solid gray'}" [(ngModel)]="poManager.current.nonFerrousAdjustment" (ngModelChange)="poManager.adjustmentChange()" inputId="currency-us" mode="currency" [currency]="userCurrency" locale="en-US" [ngModelOptions]="{standalone: true}" />
                </td>
                <!-- <td [style.width]="columns[4].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.adjustment | currency:poManager.current.currency:true}}</td> -->
            </tr>
        </table>
    </div>

    <ls-payment-types-selection [(selectedPaymentTypes)]="selectedPaymentTypes"/>

    <div *ngIf="!isCashPayment" class="seller-info">
        <div>{{sellerInfoHeaderText}}</div>
        <div style="display: flex; flex-direction: row; align-items: center; gap: 8px;">
            <p-dropdown [options]="poManager.current.vendor.contacts" [(ngModel)]="sellerContact" [ngModelOptions]="{standalone: true}"
                    optionLabel="fullName" placeholder="Select Contact" (onChange)="onSelectedContactChanged()"></p-dropdown>
            <span style="color: red; font-size: .9rem" *ngIf="sellerContact != null && !sellerContact.isContactValidForPO">Contact data is incomplete</span>
        </div>
        
        <div class="multiple-fields">
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(idText)}}</span>
                    <input type="text" pInputText [disabled]="true" [(ngModel)]="idNum" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(stateText)}}</span>
                    <input type="text" pInputText [disabled]="true" [(ngModel)]="idState" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
        </div>
    </div>

    <ls-vehicle-info [numberOptional]="false" [stateOptional]="false" *ngIf="!isCashPayment" />
    <div class="signature-section">

        <div>{{signaturePrelude}}</div>
        <div class="signature-prelude-warning">{{signaturePreludeWarning}}</div>

        <div class="multi-signature-line tall signature">
            <div class="text">{{removeUnderscores(signatureText)}}</div>
            <div class="signature-auto-expand"><ls-capture-signature #sellerSignature></ls-capture-signature></div>
        </div>

        <div class="multiple-fields name-and-date">
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(printText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.print" [ngModelOptions]="{standalone: true}" class="name"/>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(dateText)}}</span>
                    <p-calendar [(ngModel)]="poManager.current.purchaseDate" [showTime]="true" [showTime]="true" [ngModelOptions]="{standalone: true}" [styleClass]="ThemeManager.theme" appendTo="body" inputStyleClass="calendar-input-style"></p-calendar>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>Time Zone</span>
                    <p-dropdown [options]="timeZones" [(ngModel)]="selectedTimezone" [ngModelOptions]="{standalone: true}"
                        optionLabel="fullName" placeholder="Select Timezone"></p-dropdown>
                </div>
            </div>
        </div>
    </div>

    <div class="buttons">
        <div class="buttons-left">
            <p-button severity="secondary" (click)="clearSignatures()">Clear Signatures</p-button>
        </div>
        <div class="buttons-right">
            <p-button severity="secondary" (click)="onCancel()">Cancel</p-button>
            <p-button [disabled]="selectedTimezone == null || !poManager.current.totalsValid || sellerSignature.isEmpty || poManager.current.print?.length === 0 || selectedPaymentTypes.length === 0 ||
                (!isCashPayment && (poManager.current.vehicleNumber.length === 0 || poManager.current.vehicleState.length === 0 || selectedPaymentTypes.length === 0))"
                    (click)="onConfirmGeneralPage()">Confirm</p-button>
        </div>
    </div>
</form>

<div [hidden]="currentPage !== 2" class="po-pdf page-2">
    <div class="header">
        <div class="header-left">
            <div class="logo"><img src="/assets/images/ca_doj_logo.png" alt="logo"/></div>
            <div class="sub-text">
                <div>{{stateOfCAText}}</div>
                <div>{{bciaText}}</div>
                <div>{{origText}}</div>
            </div>
        </div>
        <div class="main-header">{{miscHeaderText}}</div>
        <div class="sub-text">
            <div>{{deptOfJusticeText}}</div>
            <div>{{headerPageNumberText}}</div>
        </div>
    </div>

    <div class="po-info">
        <div class="divider"></div>
        <div>{{miscLine1Text}}</div>
        <div class="divider"></div>
        <div><span class="section-label">{{removeUnderscores(dateOfSaleLabel)}}</span><span>{{poManager.current.purchaseDate| date:'MM/dd/yy'}}</span></div>
        <div class="divider"></div>

        <div class="section-label">{{placeOfSaleLabel}}</div>
        <p-dropdown [options]="placeOfSaleOptions" [(ngModel)]="poManager.current.placeOfSale" optionLabel="label" optionValue="value" (onChange)="onPlaceOfSaleOptionChanged()"></p-dropdown>
        <div class="sale-address">
            <ng-container *ngIf="poManager.current.placeOfSale === 1 || poManager.current.placeOfSale === 2">
                <div class="street-address"><div>{{placeOfSaleStreetAddress}}</div><div>{{streetAddressLabel}}</div></div>
                <div class="city"><div>{{placeOfSaleCity}}</div><div>{{cityLabel}}</div></div>
                <div class="state"><div>{{placeOfSaleState}}</div><div>{{stateLabel}}</div></div>
                <div class="zip"><div>{{placeOfSaleZip}}</div><div>{{zipLabel}}</div></div>
            </ng-container>
            <ng-container *ngIf="poManager.current.placeOfSale === 3">
                <div class="input-group street-address"><div><input type="text" pInputText [(ngModel)]="poManager.current.placeOfSaleLocationAddress"/></div><div>{{streetAddressLabel}}</div></div>
                <div class="input-group city"><div><input type="text" pInputText [(ngModel)]="poManager.current.placeOfSaleLocationCity"/></div><div>{{cityLabel}}</div></div>
                <div class="input-group state"><div><input type="text" pInputText [(ngModel)]="poManager.current.placeOfSaleLocationState"/></div><div>{{stateLabel}}</div></div>
                <div class="input-group zip"><div><input type="text" pInputText [(ngModel)]="poManager.current.placeOfSaleLocationZip"/></div><div>{{zipLabel}}</div></div>
            </ng-container>
        </div>

        <div class="divider"></div>
        <div class="section-label">{{sellerSectionLabel}}</div>

        <div style="display: flex; flex-direction: row; align-items: center; gap: 8px;">
            <p-dropdown [options]="poManager.current.vendor.contacts" [(ngModel)]="sellerContact" optionLabel="fullName" placeholder="Select Contact" (onChange)="onSelectedContactChanged()"></p-dropdown>
            <span style="color: red; font-size: .9rem" *ngIf="sellerContact != null && !sellerContact.isContactValidForPO">Contact data is incomplete</span>
        </div>

        <!-- <p-dropdown [options]="poManager.current.vendor.contacts" [(ngModel)]="sellerContact" optionLabel="fullName" placeholder="Select Contact" (onChange)="onSelectedContactChanged()"></p-dropdown> -->
        <div class="multiple-fields">
            <div class="input-group last-name"><div><input type="text" pInputText [(ngModel)]="sellerLastName" [disabled]="true"/></div><div>{{lastNameLabel}}</div></div>
            <div class="input-group first-name"><div><input type="text" pInputText [(ngModel)]="sellerFirstName" [disabled]="true"/></div><div>{{firstNameLabel}}</div></div>
            <div class="input-group middle-initial"><div><input type="text" pInputText [(ngModel)]="this.poManager.current.middleInitial"/></div><div>{{middleInitialLabel}}</div></div>
        </div>
        <div class="multiple-fields">
            <div class="input-group drivers-license-number"><div><input type="text" pInputText [(ngModel)]="sellerDriversLicenseNumber" [disabled]="true"/></div><div>{{sellerDriversLicenseLabel}}</div></div>
            <div class="input-group issuing-state"><div><input type="text" pInputText [(ngModel)]="sellerDriversLicenseIssuingState" [disabled]="true"/></div><div>{{issuingStateLabel}}</div></div>
            <div class="or-text">OR</div>
            <div class="ca-id-number"><div><input type="text" pInputText [(ngModel)]="poManager.current.californiaIdNumber"/></div><div>{{caIdLabel}}</div></div>
        </div>
        <div class="multiple-fields">
            <div class="input-group make"><div><input type="text" pInputText [(ngModel)]="poManager.current.vehicleMake"/></div><div>{{makeLabel}}</div></div>
            <div class="input-group model"><div><input type="text" pInputText [(ngModel)]="poManager.current.vehicleModel"/></div><div>{{modelLabel}}</div></div>
            <div class="input-group color"><div><input type="text" pInputText [(ngModel)]="poManager.current.vehicleColor"/></div><div>{{colorLabel}}</div></div>
        </div>
        <div class="multiple-fields">
            <div class="input-group issuing-state"><div><input type="text" pInputText [(ngModel)]="poManager.current.vehicleState"/></div><div>{{issuingStateLabel}}</div></div>
            <div class="input-group"><div><input type="text" pInputText [(ngModel)]="poManager.current.vehicleNumber"/></div><div>{{registrationLabel}}</div></div>
        </div>

        <div class="divider"></div>
        <div class="section-label">{{buyerSectionLabel}}</div>
        <div class="buyer-name">
            <div class="last-name"><div>&nbsp;</div><div>{{lastNameLabel}}</div></div>
            <div class="first-name"><div>&nbsp;</div><div>{{firstNameLabel}}</div></div>
            <div class="middle-initial"><div>&nbsp;</div><div>{{middleInitialLabel}}</div></div>
        </div>
        <div class="buyer-address">
            <div class="street-address"><div>&nbsp;</div><div>{{streetAddressLabel}}</div></div>
            <div class="city"><div>&nbsp;</div><div>{{cityLabel}}</div></div>
            <div class="state"><div>&nbsp;</div><div>{{stateLabel}}</div></div>
            <div class="zip"><div>&nbsp;</div><div>{{zipLabel}}</div></div>
        </div>
        <div class="divider"></div>
        <div class="section-label">{{descriptionSectionLabel}}</div>
        <div *ngIf="poManager.current.totalNumConverters > 0" class="item-description">
            <div class="item-type"><div>Catalytic Converters</div><div>{{itemTypeLabel}}</div></div>
            <div class="item-quantity"><div>{{poManager.current.totalNumConverters}}</div><div>{{itemQuantityLabel}}</div></div>
            <div class="item-id-number"><div>Reference Purchase Order Number: {{poManager.current.number}}</div><div>{{itemIdentificationNumberLabel}}</div></div>
        </div>
        <div *ngFor="let item of poManager.current.lineItemsMiscellaneous; let index = index" class="item-description">
            <div class="item-type"><div>{{item.description}}</div><div>{{itemTypeLabel}}</div></div>
            <div class="item-quantity"><div>{{item.quantity}}</div><div>{{itemQuantityLabel}}</div></div>
            <div class="item-id-number"><div>&nbsp;</div><div>{{itemIdentificationNumberLabel}}</div></div>
        </div>

        <div class="divider"></div>
        <div class="section-label">{{sellerStatementSectionLabel}}</div>
        <div class="seller-statement">
            <div>A.&nbsp;&nbsp;I, {{poManager.current.vendorName}}{{sellerLineAText}}</div>
            <div>B.&nbsp;&nbsp;{{sellerLineBText}} N/A</div>
        </div>

        <div class="divider"></div>
        <div class="section-label">{{thumbprintText1}}{{thumbprintText2}}{{thumbprintText3}}</div>
    </div>

    <div class="buttons">
        <div class="buttons-left">
        </div>
        <div class="buttons-right">
            <p-button severity="secondary" (click)="onCancel()">Cancel</p-button>
            <p-button [disabled]="
                sellerLastName.length === 0 ||
                sellerFirstName.length === 0 ||
                (poManager.current.placeOfSale === 3 && (
                    !poManager.current.placeOfSaleLocationAddress?.length ||
                    !poManager.current.placeOfSaleLocationCity?.length ||
                    !poManager.current.placeOfSaleLocationState?.length ||
                    !poManager.current.placeOfSaleLocationZip?.length)) ||
                poManager.current.vehicleNumber?.length === 0 ||
                poManager.current.vehicleState?.length === 0 ||
                (sellerDriversLicenseNumber.length === 0 && poManager.current.californiaIdNumber?.length === 0) || (sellerDriversLicenseNumber.length > 0 && sellerDriversLicenseIssuingState.length === 0)"
                (click)="onConfirmRecordOfSalePage()">Confirm</p-button>
        </div>
    </div>
</div>
